module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/3_520c8762edfb25a67a065c881d3242ab.png";